import { Box } from '@mui/material'

interface YouTubeEmbedProps {
  videoId: string
  title?: string
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ videoId, title = 'YouTube video' }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: '56.25%', // 16:9 aspect ratio
        borderRadius: 2,
        overflow: 'hidden',
        border: '3px solid rgba(226,90,11,0.3)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        '&:hover': {
          borderColor: 'primary.main',
          boxShadow: '0 6px 25px rgba(226,90,11,0.2)'
        },
        transition: 'all 0.3s ease'
      }}
    >
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none'
        }}
      />
    </Box>
  )
}

export default YouTubeEmbed
